import {
  CAP_G03,
  CAP_G06,
  CAP_SPACE_04,
  CAP_SPACE_12,
  CAP_SPACE_16,
  CAP_SPACE_24,
  CAP_SPACE_40,
  CAP_SPACE_56,
  CAP_COLOR_06,
  CAP_COLOR_03,
  FONT_COLOR_01,
  FONT_COLOR_04,
  FONT_SIZE_M,
  FONT_WEIGHT_MEDIUM,
  FONT_WEIGHT_REGULAR,
  CAP_SPACE_08,
  CAP_SPACE_20,
  FONT_COLOR_05,
  CAP_COLOR_08,
  CAP_PALE_GREY,
  CAP_RED,
  CAP_WHITE,
  CAP_G01,
  FONT_FAMILY,
  CAP_SECONDARY,
} from '@capillarytech/cap-ui-library/styled/variables';
import { createGlobalStyle } from 'styled-components';
import { MODAL_WINDOW_MAX_WIDTH } from './components/pages/App/constants';

const GlobalStyle = createGlobalStyle`
html,
  body {
    height: 100%;
    width: 100%;
    font-family: 'Roboto', Arial, sans-serif;
    font-size: 14px;
    line-height: unset;
  }

  body.fontLoaded {
    font-family: 'Roboto', Arial, sans-serif;
  }
  
.pointer-cursor {
    cursor: pointer;
  }
  
.badges-image-tooltip {
  .ant-tooltip-inner {
    background-color: ${CAP_WHITE} !important;
    padding: ${CAP_SPACE_16} ${CAP_SPACE_24} !important;
  }
  .ant-tooltip-arrow {
    border-right-color: ${CAP_WHITE} !important;
  }
}

.tooltip-divider {
    margin: 0.5rem 0rem;
    background: ${CAP_G03} !important;
  }

.owners-tooltip-content {
    .ant-tooltip-content .ant-tooltip-inner{
        padding: ${CAP_SPACE_16} ${CAP_SPACE_24} !important;
        width: 26.571rem !important;
        max-height: 17rem !important;
        min-height: 10rem !important;
        overflow-y:scroll;
    }
    .owner-header-section{
      gap: ${CAP_SPACE_24};
      .owners-tooltip-header {
        font-size: ${FONT_SIZE_M};
        font-weight: ${FONT_WEIGHT_MEDIUM};
        display: inline-block;
      }
      .owners-tooltip-subheader {
        font-size: ${FONT_SIZE_M};
        color: ${CAP_G06};
        display: inline-block;
        margin-left: 0.2rem;
      }
    }
    .owner-header-section > :first-child {
      width: 8.4rem;
    }
  .owners-tooltip-body-container {
      display: flex;
      gap: ${CAP_SPACE_12};
      flex-direction: column;
    .owner-row{
      gap:${CAP_SPACE_24};
      flex-flow: unset;
      .owners-tooltip-body {
        display: flex;
        gap: ${CAP_SPACE_12};
        flex-direction: column;
        width: 12rem;
         .owner-message{
            width: 100%;
         }
      }
      .owners-tooltip-tag-parent {
        width: 8.4rem;
        .owners-tooltip-colored-tag{
          font-weight: 400;
          line-height: 0.857rem;
          padding: 0.143rem ${CAP_SPACE_08};
          height: unset;
          text-wrap: balance;
          vertical-align: top;
          font-weight: ${FONT_WEIGHT_REGULAR};
          line-height: ${CAP_SPACE_12};
          width: max-content;
        }
      }    
    }
  }
}

// CSS Override issue fix - multi select,coupons integration
  .ant-tree{
    li .ant-tree-treenode-switcher-open .ant-tree-checkbox {
      margin-left: 0 !important;
      margin-right: 0  !important;
      margin: 4px 4px 0 2px !important;
    }
    .ant-tree-checkbox-checked {
      .ant-tree-checkbox-inner::after{
        top: 50% !important;
        left: 21% !important;
        transform: rotate(45deg) scale(1) translate(-50%, -50%);
      }
    }
    .ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner::after,
    .ant-tree-checkbox-inner::after{
      top: 50% !important;
      left: 21% !important;
      transform: translate(0%, -50%) scale(1);
    }
  }
  .ant-popover.cap-multi-select-v2-popover .select-all-tree > span:nth-child(2) {
    margin-left: 20px !important;
    margin-right: 4px !important;
    margin-top: 4px !important;
  }
  
  .coupon-benefits-wrapper{
      display: flex !important;
      flex-direction: column !important;
      align-content: flex-start !important;
        .align-headings{
          width: 100%;
        }
        .coupons-view {
        margin-top: 10px !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
        text-align: start !important;
      }
      .coupon-config-component {
        padding: 0 !important;
        .preview-container{
          height: calc(100vh - 14.28rem) !important;
          width: 60% !important
        }
      }
        .coupons-create-container {
            width: 170% !important;
            text-align: start !important;
        }
        .ant-tabs {
        text-align: start !important;
    }
    .footer{
      .ant-btn.cap-button-v2 {
          margin-left: 0 !important;
      }
    }
    .cap-panes {
    width: 63.5% !important;
    margin-left: -48px !important;
    text-align: start !important;
    }

    .upload-component-container {
    padding-right: 0 !important;
    margin-left: -48px !important;
}
    .revoke-component .revoke-component-container {
        margin-left: -48px !important;
        text-align: start !important;
    }
  }

.coupons-view-container .cap-table-v2.coupons-table-library-mode .ant-table-tbody > tr > td {
    padding: 1.142rem 1.857rem !important;
}
.selected-badge-benefits{
    margin: 1rem 0 0 1.714rem;
}
 
  // CSS Override issue fix - points selection integration
  .points-table {
      margin-top: ${CAP_SPACE_24} !important;
      margin-left: 0 !important; 
      margin-right: 0 !important;
        .bdHnKk {
          padding-right: 1.428rem !important;
      }
  }
   .point-startegies-container .points-col {
        text-align: start !important;
   }
      .point-startegies-container .points-footer {
          margin-left: 0 !important; 
          position: fixed !important;
          bottom: 0 !important;
      }



  // temp fix
  // Need to handle in cap-react-ui-library
  .ant-input-affix-wrapper, .ant-calendar-picker{ .ant-input{
      height: ${CAP_SPACE_40};
      border: 1px solid ${FONT_COLOR_04} !important;
      border-radius: ${CAP_SPACE_04} !important;

      &:focus, &:hover{
        border-color: ${FONT_COLOR_01}!important;
    }
  }
  }
  .ant-radio-inner::after {
    top: 1px !important;
    left: 1px !important;
  }
  
  .ant-radio-checked .ant-radio-inner {
  border: 2px solid #47AF46 !important; 
  }

  .ant-radio-inner {
    width: 1rem !important;
    height: 1rem !important;
    border-radius: 1rem !important; 
  }

  .cap-radio.ant-radio-wrapper {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    line-height: 2rem; } 

  .ant-checkbox-inner::after {
    top: 46% !important;
  }

.preview-wrapper {
    height: calc(100vh - 6.571rem - 6.286rem) !important;
    .view-badges-benefits {
      min-height: calc(100vh - 12rem) !important;
    }
  }

.view-badges-slidebox {
    text-align: left;
    .size-l {
      width: 81.429rem;
    }
    .slidebox-content-container {
      overflow-y: hidden;

      .basic-details-copy-icon {
        cursor: pointer;
        color: ${CAP_SECONDARY.base};
      }
    }
    .not-defined-message {
      color: ${FONT_COLOR_04};
    }
    .view-badge-header {
      text-align: left;
      .ant-skeleton-paragraph {
        margin-bottom: 0 !important;
        li {
          width: 100% !important;
        }
      }
      .badge-header {
        margin-bottom: ${CAP_SPACE_04};
      }
      .badge-name {
        margin-left: ${CAP_SPACE_04};
      }
      .badge-status {
        margin-left: ${CAP_SPACE_04};
        margin-right: ${CAP_SPACE_04};
        .active-tag-value {
          font-weight: ${FONT_WEIGHT_REGULAR};
        }
        .status-container {
          margin-top: 0 !important;
        }
      }
    }
    .view-badges-slidebox-content {
      .view-badges-enrol-section {
      display: none;
    }
      .view-badges-empty-benefits-section {
        min-height: calc(100vh - 30rem);
        visibility: hidden;
      }
      .preview-badges-empty-benefits-section {
        min-height: calc(100vh - 22rem);
        visibility: hidden;
      }
      text-align: left;
      .view-badges-slidebox-card {
        cursor: pointer;
        padding: ${CAP_SPACE_24} ${CAP_SPACE_12};
        margin-left: 2px;

        &::before {
          content: '';
          width: 2px;
          height: 0;
          position: absolute;
          top: 0;
          left: -2px;
          transition: height 0.25s;
        }

        &:hover {
          background-color: ${CAP_COLOR_08};
          transition: background 0.5s;

          &::before {
            height: 100%;
            background-color: ${CAP_COLOR_08};
          }
        }

        &.card-selected {
          background: ${CAP_PALE_GREY};

          &::before {
            content: '';
            width: 2px;
            height: 100%;
            background-color: ${FONT_COLOR_05};
            position: absolute;
            top: 0;
            left: -2px;
          }
        }

        .card-title {
          margin-bottom: ${CAP_SPACE_04};
          font-family: ${FONT_FAMILY};
        }
      }

      .view-badges-details-wrapper {
        scroll-behavior: smooth;
        padding-left: ${CAP_SPACE_20};
        overflow-y: scroll;
        height: calc(100vh - 92px - 60px - 88px);

        .view-badges-basic-details {
          margin-bottom: ${CAP_SPACE_24};
            .basic-details-images-container-wrapper {
              margin-top: -${CAP_SPACE_20};
          }
          .basic-details-header {
            margin-bottom: ${CAP_SPACE_16};
            font-size: ${CAP_SPACE_20};
            color: ${CAP_G01};
          }
          .custom-fields-container {
            .custom-field-header {
              margin-bottom: ${CAP_SPACE_16};
            }
          }
          .view-badges-owner-scope-section {
            .owner-scope-container {
              margin-bottom: ${CAP_SPACE_16};
            }
            .owner-scope-tag {
              height: ${CAP_SPACE_16};
              margin-bottom: ${CAP_SPACE_04};
            }
            .owner-scope-value {
              margin-bottom: ${CAP_SPACE_04};
            }
            .dash-text {
              margin-right: ${CAP_SPACE_12};
            }
            .error-message {
              color: ${CAP_RED};
            }
            .error-message-icon {
              margin-right: ${CAP_SPACE_04};
              vertical-align: baseline;
            }
          }
          .earn-type-info-icon {
            padding-left: ${CAP_SPACE_04};
          }
          .badge-id {
            margin: 0 ${CAP_SPACE_04};
          }
          .view-more-less-button {
            color: ${CAP_SECONDARY.base};
            font-size: ${FONT_SIZE_M};
            font-weight: ${FONT_WEIGHT_MEDIUM};
            cursor: pointer;
            margin-top: ${CAP_SPACE_04};
          }
          .custom-field-visible {
            scroll-margin-top: 3.571rem;
            max-height: fit-content;
            overflow: visible;
            white-space: pre-line;
          }
          .custom-field-hidden {
            scroll-margin-top: 3.571rem;
            max-height: 14.643rem;
            overflow: hidden;
            white-space: pre-line;
          }
        }

        .view-badges-earn {
          .earn-header {
            margin-bottom: ${CAP_SPACE_16};
            font-size: ${CAP_SPACE_20};
            color: ${CAP_G01};
          }
          
          .earn-limits-cycle-info-note{
            width: fit-content;
            max-width: 99%;
          }

          .earn-limit-table {
            margin-right: ${CAP_SPACE_08};
            margin-top: ${CAP_SPACE_04};
            .period-col-title{
                margin-top: ${CAP_SPACE_08};
              }
            .ant-table-thead > tr > th {
              font-weight: ${FONT_WEIGHT_REGULAR};
              vertical-align: top;
            }
            .ant-table-tbody > tr > td {
              vertical-align: top;
            }
            .ant-table-tbody > tr.ant-table-row:hover > td {
              background: unset !important;
            }
            .earn-limit-type {
              margin-right: ${CAP_SPACE_08};
            }
          }

          .badges-earn-tooltip {
            .sync-icon {
              width: ${CAP_SPACE_20};
              height: ${CAP_SPACE_20};
              display: flex;
              align-items: center;
              justify-content: center;
              svg {
                width: ${CAP_SPACE_16};
                height: ${CAP_SPACE_16};
              }
            }
            .sync-message {
              color: ${CAP_WHITE};
              font-size: ${FONT_SIZE_M};
              font-weight: ${FONT_WEIGHT_MEDIUM};
              line-height: ${CAP_SPACE_20} !important;
              margin-left: ${CAP_SPACE_04};
            }
          }
        }

        .view-badges-benefits {
          min-height: calc(100vh - 17rem);
          .benefits-header {
            margin-bottom: ${CAP_SPACE_16};
            font-size: ${CAP_SPACE_20};
            color: ${CAP_G01};
          }
          .hidden-icon {
            //hiding a warning icon to prevent display glitch
            font-size: 0;
            position: fixed;
            z-index: -1;
          }
        }
      }
    }
  }

  .cap-slide-box-v2-container .slidebox-footer {
    .ant-btn.cap-button-v2.ant-btn-primary {
      margin-right: 16px !important;
    }
  }

  .coupons-create-container .footer {
    width: 1140px !important;
  }

  .date-picker-error{
    .ant-input-affix-wrapper .ant-input, .ant-calendar-picker .ant-input {
      border: 1px solid ${CAP_COLOR_03} !important;
    }
  }
  .error-border{
    .ant-input-affix-wrapper .ant-input{
      border: 1px solid ${CAP_COLOR_03} !important;
    }
  }

 //CSS override for date picker - typing should be disabled
  .ant-calendar-input-wrap {
    height: 34px;
    padding: 6px 10px;
    border-bottom: 1px solid #e8e8e8;
    display: none !important;
  }

  // styles were not getting applied on component level, therefore moved here
  .select-custom-fields-popup{
    width: 29.2rem !important;
    padding-left: 0.6rem;
  }
  .header-message-wrapper {
    .size-l {
    width: 81.429rem !important;
      }
  }
  // styles were not getting applied on component level, therefore moved here
  .custom-fields-slidebox{
      .slidebox-footer{
        .slidebox-done-button{
          margin-left:1.714rem;
      }
    }
  }
  .ant-select-dropdown-menu-item-disabled {
  cursor: not-allowed !important;
  font-size: ${CAP_SPACE_12} !important;
  color: #00000040 !important;
  }


  // Overriding css because support for new nav is absent in this module
  .on-settings-page{
    .cap-component-wrapper {
      max-width: unset !important;
      margin: 0 !important;
      padding: ${CAP_SPACE_24} 0;
    }
    .cap-component-wrapper > div {
      overflow: auto !important;
    }
    .cap-component-wrapper > div > div:nth-of-type(1) {
      margin-top: -${CAP_SPACE_24} !important;
    }
    .cap-component-wrapper > div > div:nth-of-type(2) {
      width: 100% !important;
    }
  }

  .on-listings-page{
    .cap-component-wrapper {
        max-width: 81.429rem !important;
        margin: 0 auto;
        padding: ${CAP_SPACE_24} 0;
        height: max-content;
    }
    .cap-component-wrapper > div {
      overflow: auto !important;
    }
  }

  .on-not-enabled-page{
    .cap-component-wrapper {
      max-width: 81.429rem !important;
      margin: 0 auto;
      padding: ${CAP_SPACE_24} 0;
      height: max-content;
    }
    .cap-component-wrapper > div {
      overflow: visible !important;
    }
  }

  .confirmation-modal-primary-desc{
    margin: -${CAP_SPACE_12} 0 ${CAP_SPACE_08} 0; 
    line-height: ${CAP_SPACE_16};
  }

  .confirmation-modal-secondary-desc{
    margin-bottom: 1rem;
    line-height: ${CAP_SPACE_16};
  }

  .remove-issue-limits-confirmation-modal{
    .ant-modal-content{
      width: ${MODAL_WINDOW_MAX_WIDTH};
      .ant-modal-footer{
        padding-left: ${CAP_SPACE_24} !important;
      }
      .ant-modal-close{
        margin-top: -0.429rem;
      }
    }
  }
  
  .cap-info-note-fit-content {
    width: fit-content;
    .note-message-container .note-text{
      margin-top: 0.143rem;
    }
  }

  .text-capitalize {
    text-transform: capitalize;
  }

  //generic css override due to react-18 upgrade
  .ant-input {
    font-size: ${FONT_SIZE_M} !important;
  }
  .ant-tabs-tabpane{
    border: none !important;
  }
  .ant-radio-wrapper{
    font-family: ${FONT_FAMILY} !important;
  }
  .ant-calendar-disabled-cell.ant-calendar-selected-day {
    .ant-calendar-date::before {
      background: none !important;
    }
    .ant-calendar-date {
      background: #f5f5f5 !important;
    }
  }
  .ant-calendar-selected-day {
    .ant-calendar-date {
      background: transparent !important;
    }
  }
  .ant-calendar-selected-date:not(.ant-calendar-disabled-cell) {
    .ant-calendar-date {
      background: ${FONT_COLOR_05} !important;
    }
  }
`;

export default GlobalStyle;
